import { render, staticRenderFns } from "./department.vue?vue&type=template&id=20e1eed7&scoped=true"
import script from "./department.vue?vue&type=script&lang=js"
export * from "./department.vue?vue&type=script&lang=js"
import style0 from "./department.vue?vue&type=style&index=0&id=20e1eed7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e1eed7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e1eed7')) {
      api.createRecord('20e1eed7', component.options)
    } else {
      api.reload('20e1eed7', component.options)
    }
    module.hot.accept("./department.vue?vue&type=template&id=20e1eed7&scoped=true", function () {
      api.rerender('20e1eed7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/department.vue"
export default component.exports